import { Chevron, Header, LeftContainer, PopoverButton, PopoverRow, ThemeProp } from '@trarc/pc-shared';
import styled from 'styled-components';

import qaBackground from '../../assets/qa-background.png';
import stagingBackground from '../../assets/staging-background.png';
import { EnvironmentName } from '../../types/api.graphql';

const getSidebarBackgroundImage = () => {
  const environmentName: EnvironmentName = process.env.REACT_APP_ENVIRONMENT as EnvironmentName;
  switch (environmentName) {
    case EnvironmentName.Qa:
      return `url(${qaBackground})`;
    case EnvironmentName.Staging:
      return `url(${stagingBackground})`;
    default:
      return 'none';
  }
};

export const SharedHeader = styled(Header)`
  background-image: ${getSidebarBackgroundImage()};

  ${LeftContainer} {
    background: ${(props: ThemeProp) => props.theme.colors.white};
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }: ThemeProp) => theme.colors.black};
  font-weight: ${({ theme }: ThemeProp) => theme.fontWeight.bold};
  font-size: ${({ theme }: ThemeProp) => theme.fontSize.xs};
`;

export const UserInfo = styled.div`
  display: flex;
  color: transparent;
  background-color: transparent;
  border: none;
  border-radius: 2px;

  &:focus-visible {
    box-shadow: 0 0 0 2px ${({ theme }: ThemeProp) => theme.colors.white},
      0 0 0 4px ${(props: ThemeProp) => props.theme.colors.black};
  }
`;

export const UserName = styled.span`
  color: ${(props: ThemeProp) => props.theme.colors.black};
  padding: ${5 / 16}rem ${10 / 16}rem;
  padding-left: 0;
  margin: auto;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 20rem;

  &:hover {
    color: ${(props: ThemeProp) => props.theme.colors.primary};
    text-decoration-line: underline;
  }
`;

export const StyledChevronIcon = styled(Chevron)`
  flex-shrink: 0;
  stroke: ${(props: ThemeProp) => props.theme.colors.black};
  align-self: center;
  height: 1.5rem;
  width: 1.5rem;
`;

export const UserActionDropdownRow = styled(PopoverRow)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ShadowEntityContainer = styled.div`
  display: flex;
  max-width: 20rem;
  background: ${(props: ThemeProp) => props.theme.colors.white};
`;

export const ShadowEntityLabel = styled.div`
  margin-right: 0.3rem;
  display: flex;
  color: ${(props: ThemeProp) => props.theme.colors.c400};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-family: ${(props: ThemeProp) => props.theme.fonts.primary};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ShadowEntityText = styled.div`
  color: ${(props: ThemeProp) => props.theme.colors.black};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledPopoverButton = styled(PopoverButton)`
  background: ${(props: ThemeProp) => props.theme.colors.white};
`;
